import * as ComplementProbabilityTask from "./ComplementProbabilityTask";
import * as UnionProbabilityTask from "./UnionProbabilityTask";
import * as IntersectionProbabilityTask from "./IntersectionProbabilityTask";
import * as DisjointEventsUnionTask from "./DisjointEventsUnionTask";

export const registry = {
  ComplementProbabilityTask,
  UnionProbabilityTask,
  IntersectionProbabilityTask,
  DisjointEventsUnionTask
};

const modules = [
  ComplementProbabilityTask,
  UnionProbabilityTask,
  IntersectionProbabilityTask,
  DisjointEventsUnionTask
];

export function generateTasks() {
  return modules.map((module) => module.generateTask());
}

function moduleFor(task) {
  const module = registry[task.type];
  if (!module) throw new Error("Nieznany typ zadania ze zdarzeń: " + task.type);
  return module;
}

export function renderTask(task) { return moduleFor(task).renderTask(task); }
export function renderInput(task, ua, onChange, disabled) { return moduleFor(task).renderInput(task, ua, onChange, disabled); }
export function checkAnswer(task, ua) { return moduleFor(task).checkAnswer(task, ua); }
export function renderAnswer(task) { return moduleFor(task).renderAnswer(task); }
export function renderExplanation(task) { return moduleFor(task).renderExplanation(task); }
export function renderUserAnswer(ua, task) {
  const module = registry[task.type];
  return typeof module?.renderUserAnswer === "function" ? module.renderUserAnswer(ua, task) : null;
}